import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {FilterRadioCheckbox} from "../../../search/components/generic_filters/FilterRadioCheckbox";
import {SearchFilterTypes} from "../../../search/types/SearchFilterTypes";
import {IPropertyConfiguratorSearchFiltersFormValues} from "../../reducers/property_configurator_reducer";

interface IOwnProps {}
interface IProps extends IFormProps<IPropertyConfiguratorSearchFiltersFormValues>, IOwnProps {}

const ConstructionEndDateFilterC = (props: IProps) => {
    const constructionEndDateProps = props.getFieldProps("construction_end_date");

    const onChange = (name: string, value: (string | number)[]) => {
        const mapedValues = value.reduce((acc, singleValue) => {
            if (typeof singleValue === "string") {
                const numericValue = parseInt(singleValue);
                !isNaN(numericValue) && acc.push(numericValue);
            } else {
                acc.push(singleValue);
            }
            return acc;
        }, [] as number[]);

        constructionEndDateProps.onChange(name, mapedValues);
    };

    return (
        <div>
            <Text color={getThemeVariable("colors.gray.700")} variant="body_copy_1" mb={1.5}>
                Termin oddania
            </Text>

            <FilterRadioCheckbox filter={filter} value={constructionEndDateProps.value} onChange={onChange} />
        </div>
    );
};

export const ConstructionEndDateFilter = form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(ConstructionEndDateFilterC);

const filter = {
    id: "construction_end_date",
    type: SearchFilterTypes.RADIO,
    filterOptions: [
        {id: "0", value: 0, label: "Gotowe do odbioru"},
        {id: "3", value: 3, label: "Do 3 miesięcy"},
        {id: "6", value: 6, label: "Do 6 miesięcy"},
        {id: "12", value: 12, label: "Do roku"},
        {id: "36", value: 36, label: "Do 3 lat"}
    ]
};
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {form, IFormProps} from "@pg-mono/form";

import {FilterRadioCheckbox} from "../../../search/components/generic_filters/FilterRadioCheckbox";
import {SearchFilterTypes} from "../../../search/types/SearchFilterTypes";
import {IPropertyConfiguratorSearchFiltersFormValues} from "../../reducers/property_configurator_reducer";

interface IOwnProps {}
interface IProps extends IFormProps<IPropertyConfiguratorSearchFiltersFormValues>, IOwnProps {}

const ConstructionEndDateFilterC = (props: IProps) => {
    const constructionEndDateProps = props.getFieldProps("construction_end_date");

    const onChange = (name: string, value: (string | number)[]) => {
        const mapedValues = value.reduce((acc, singleValue) => {
            if (typeof singleValue === "string") {
                const numericValue = parseInt(singleValue);
                !isNaN(numericValue) && acc.push(numericValue);
            } else {
                acc.push(singleValue);
            }
            return acc;
        }, [] as number[]);

        constructionEndDateProps.onChange(name, mapedValues);
    };

    return (
        <div>
            <Text color={getThemeVariable("colors.gray.700")} variant="body_copy_1" mb={1.5}>
                Termin oddania
            </Text>

            <FilterRadioCheckbox filter={filter} value={constructionEndDateProps.value} onChange={onChange} />
        </div>
    );
};

export const ConstructionEndDateFilter = form<IPropertyConfiguratorSearchFiltersFormValues, IProps>(ConstructionEndDateFilterC);

const filter = {
    id: "construction_end_date",
    type: SearchFilterTypes.RADIO,
    filterOptions: [
        {id: "0", value: 0, label: "Gotowe do odbioru"},
        {id: "3", value: 3, label: "Do 3 miesięcy"},
        {id: "6", value: 6, label: "Do 6 miesięcy"},
        {id: "12", value: 12, label: "Do roku"},
        {id: "36", value: 36, label: "Do 3 lat"}
    ]
};
